import AppActions from './actions.js';
import AppMutations from './mutations.js';
import AppState from './state.js';

const module = {
  namespaced: true,
  state: () => (AppState),
  mutations: AppMutations,
  actions: AppActions
}

export default module;
  